import { useEffect } from 'react';
import Navbar from './Components/Navbar/Navbar';
import Intro from './Components/Intro/Intro';
import { background } from '../../js/background';
import Projects from './Components/Projects/Projects';
import Technologies from './Components/Technologies/Technologies';
import Certificates from './Components/Certificates/Certificates';
import Contact from './Components/Contact/Contact';
import Footer from './Components/Footer/Footer';
import { mobileCheck } from '../../Misc/essential';
import Preview from './Components/Preview/Preview';
export default function HomePage() {
    useEffect(() => {
        if (!mobileCheck()) {
            background()
        }
    }, [])
    return (
        <div className="">
            <canvas id='bg-canvas' width={"100%"} height={"100%"} className='absolute top-0 -z-50'>
            </canvas>
            <Navbar />
            <Intro />
            <Projects />
            <Preview/>
            <Technologies />
            <Certificates />
            <Contact />
            <Footer />
        </div>
    );
}